import { supabase } from '../lib/supabase';

let isProcessing = false;
let processingInterval: NodeJS.Timeout | null = null;

export const startEmailQueueProcessor = () => {
  if (processingInterval) {
    return;
  }

  console.log('[EmailQueueProcessor] Starting automatic email queue processor...');

  const processQueue = async () => {
    if (isProcessing) {
      return;
    }

    try {
      isProcessing = true;

      const { count } = await supabase
        .from('email_notification_queue')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'pending');

      if (!count || count === 0) {
        return;
      }

      console.log(`[EmailQueueProcessor] Processing ${count} pending emails...`);

      const response = await fetch(
        `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email-notification/process-queue`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        console.log(`[EmailQueueProcessor] Processed ${result.processed || 0} emails successfully`);
      } else {
        console.error('[EmailQueueProcessor] Error processing queue:', await response.text());
      }
    } catch (error) {
      console.error('[EmailQueueProcessor] Error:', error);
    } finally {
      isProcessing = false;
    }
  };

  processQueue();

  processingInterval = setInterval(() => {
    processQueue();
  }, 30000);
};

export const stopEmailQueueProcessor = () => {
  if (processingInterval) {
    clearInterval(processingInterval);
    processingInterval = null;
    console.log('[EmailQueueProcessor] Stopped automatic email queue processor');
  }
};

export const processEmailQueueNow = async () => {
  console.log('[EmailQueueProcessor] Manual processing triggered...');

  try {
    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-email-notification/process-queue`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (response.ok) {
      const result = await response.json();
      console.log(`[EmailQueueProcessor] Manually processed ${result.processed || 0} emails`);
      return result;
    } else {
      const error = await response.text();
      console.error('[EmailQueueProcessor] Error:', error);
      throw new Error(error);
    }
  } catch (error) {
    console.error('[EmailQueueProcessor] Error processing queue:', error);
    throw error;
  }
};
